import { GamificationModalContainer } from "shared/components/molecules/Gamification/GamificationModal/atoms/Container";
import { GamificationModalSubtitle } from "shared/components/molecules/Gamification/GamificationModal/atoms/Subtitle";
import { GamificationModalTitle } from "shared/components/molecules/Gamification/GamificationModal/atoms/Title";
import { GamificationModalUserPhoto } from "shared/components/molecules/Gamification/GamificationModal/atoms/UserPhoto";

export const GamificationModal = {
  Container: GamificationModalContainer,
  Title: GamificationModalTitle,
  Subtitle: GamificationModalSubtitle,
  UserPhoto: GamificationModalUserPhoto,
};
